import React from 'react';
import {
  Paper,
  Box,
  Button,
  Stack,
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Palette as PaletteIcon,
  Lock as PrivacyIcon,
  Security as SecurityIcon,
  Cloud as CloudIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';
import { TabItem, PermissionUtils } from './types';

interface ApplicationTabNavigationProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
  permissionUtils: PermissionUtils;
}

const ApplicationTabNavigation: React.FC<ApplicationTabNavigationProps> = ({
  activeTab,
  onTabChange,
  permissionUtils
}) => {
  const { canAccessSection } = permissionUtils;

  const tabItems: TabItem[] = [
    { id: 'general', label: 'General', icon: <SettingsIcon />, permission: 'general' },
    { id: 'theme', label: 'Application Theme', icon: <PaletteIcon />, permission: 'theme' },
    { id: 'privacy', label: 'Data & Privacy', icon: <PrivacyIcon />, permission: 'privacy' },
    { id: 'security', label: 'Security & Privacy', icon: <SecurityIcon />, permission: 'security' },
    { id: 'storage', label: 'Storage', icon: <CloudIcon />, permission: 'storage' },
    { id: 'advanced', label: 'Advanced', icon: <WarningIcon />, permission: 'advanced' },
  ];

  // Filter tabs based on permissions
  const availableTabs = tabItems.filter(tab => 
    canAccessSection(tab.permission as any)
  );

  return (
    <Paper sx={{ mb: 1 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Stack direction="row" spacing={0}>
          {availableTabs.map((tab) => (
            <Button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              startIcon={tab.icon}
              sx={{
                py: 2,
                px: 3,
                borderRadius: 0,
                borderBottom: activeTab === tab.id ? 2 : 0,
                borderColor: 'primary.main',
                backgroundColor: activeTab === tab.id ? 'primary.50' : 'transparent',
                color: activeTab === tab.id ? 'primary.main' : 'text.secondary',
                '&:hover': {
                  backgroundColor: 'primary.50',
                },
              }}
            >
              {tab.label}
            </Button>
          ))}
        </Stack>
      </Box>
    </Paper>
  );
};

export default ApplicationTabNavigation;